import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    CURRENT_REQUEST: (id) => ({
        url: `substitutor/current-request/${id}`,
        method: "get",
    }),

    OPEN_REQUEST: (id) => ({
        url: `substitutor/open-request/${id}`,
        method: "get",
    }),

    ALL_REQUEST: (id) => ({
        url: `substitutor/all-request/${id}`,
        method: "get",
    }),

    FULL_PERIOD: (id) => ({
        url: `substitutor/full-period/${id}`,
        method: "get",
    }),

    UPDATE_SUBSTITUTION_STATUS: (id) => ({
        url: `substitutor/substitution/${id}/dayparts`,
        method: "post",
    }),
};

export const useCurrentRequest = (id) =>
    useApiFetcherSWR(id ? API_ENDPOINT.CURRENT_REQUEST(id) : null);

export const useOpenRequest = (id) =>
    useApiFetcherSWR(id ? API_ENDPOINT.OPEN_REQUEST(id) : null);

export const useAllRequest = (id) =>
    useApiFetcherSWR(id ? API_ENDPOINT.ALL_REQUEST(id) : null);

export const useFullPeriod = (id) =>
    useApiFetcherSWR(id ? API_ENDPOINT.FULL_PERIOD(id) : null);

export const useUpdateSubstitutionStatus = (id) =>
    useApiFetcherSWR(id ? API_ENDPOINT.UPDATE_SUBSTITUTION_STATUS(id) : null);